import { Stack, Typography, useTheme } from "@mui/material";
import { CopyIcon, Input } from "components";
import toast from "react-hot-toast";

export const CopyAssertionAndAudienceUrl = ({
  assertionUrl,
  audienceUri,
}: {
  assertionUrl: string;
  audienceUri: string;
}) => {
  const theme = useTheme();
  const containerStyles = {
    padding: "16px 24px",
    border: `1px solid ${theme.palette.neutral["010"]}`,
    borderRadius: "8px",
    bgcolor: theme.palette.neutral.main,
  };
  const copyAssertionUrl = async () => {
    try {
      await navigator.clipboard.writeText(assertionUrl);
      toast.success("Redirect URL copied to clipboard");
    } catch (error) {
      toast.error("Failed to copy to clipboard");
    }
  };

  const copyAudienceUri = async () => {
    try {
      await navigator.clipboard.writeText(audienceUri);
      toast.success("Redirect URL copied to clipboard");
    } catch (error) {
      toast.error("Failed to copy to clipboard");
    }
  };
  return (
    <Stack
      sx={{
        gap: "24px",
        ...containerStyles,
      }}
    >
      <Stack>
        <Typography variant="h6">Configure in the IDP</Typography>
        <Typography variant="body-small" color={theme.palette.lightBg.low}>
          {/* Set up an application integration using SAML 2.0 in your identity
          provider. Enter the details provided by Logto. */}
          Set up a SAML 2.0 enterprise application in your identity provider
          using the following details.
        </Typography>
      </Stack>
      <Stack gap="12px">
        <Input
          name="spEntityId"
          label="Audience URL (identifier / entity ID)"
          value={audienceUri}
          disabled={true}
          InputProps={{
            endAdornment: (
              <CopyIcon
                style={{
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                }}
                onClick={copyAudienceUri}
              />
            ),
          }}
        />
        <Input
          name="assertion_consumer_service_url"
          label="Assertion consumer service URL (reply URL)"
          value={assertionUrl}
          disabled={true}
          InputProps={{
            endAdornment: (
              <CopyIcon
                style={{
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                }}
                onClick={copyAssertionUrl}
              />
            ),
          }}
        />
      </Stack>
    </Stack>
  );
};
